import { TabProps } from "../Tab";
import { TabState } from "../context/TabContext";
import { tabReducer } from "../reducer/tabReducer";
import { useCallback, useEffect, useReducer, useRef } from "react";

export interface TabContextState {
  changeActiveTab: (id: any) => void;
  activeTab: any;
}

export enum Action {
  ChangeActiveTab,
}

export interface ActionTypes {
  type: Action;
  id?: any;
  index?: number;
}

export const useTabContextProvider = (reducer: typeof tabReducer, initial: TabState, props: TabProps) => {
  const [state, dispatch] = useReducer(reducer, initial);
  const isFirstRender = useRef(true);

  const changeActiveTab = useCallback(
    (id: any, isUserAction = true) => {
      dispatch({ id, type: Action.ChangeActiveTab });

      if (typeof props.onChange === "function" && isUserAction) {
        props.onChange(id);
      }
    },
    [props]
  );

  useEffect(() => {
    if (props.initTab !== undefined) {
      if (isFirstRender.current) {
        isFirstRender.current = false;
        dispatch({ id: props.initTab, type: Action.ChangeActiveTab });
      } else {
        changeActiveTab(props.initTab, false);
      }
    }
  }, [props.initTab]);

  return {
    changeActiveTab: (id: any) => changeActiveTab(id, true),
    activeTab: state.activeTab,
  };
};
